import React from 'react';

import { VIEWER_RELATIONSHIP_TAG, VIEWER_RELATIONSHIP_YOU_TEXT as YOU_TEXT } from '../../constants/admission';

/**
 * ViewerRelationshipChip (admission-access M-FE-2, S16/S17) — the viewer's own
 * place on an admission's care team, read off `viewer_relationship` (the server
 * derives it per caller: PRIMARY | ADDED | null — non-doctors are always null,
 * so no role is checked here). One chip for every surface:
 *   - tag  (rail row, IPD page row): "Primary" / "Added" — copy-ratified #32
 *   - you  (workspace header, IPD details): mockup "You · Primary doctor" /
 *          "You · Added doctor" (not in copy-ratified — PO to ratify)
 * Renders nothing for a null / unknown relationship.
 */
export const VIEWER_RELATIONSHIP = { PRIMARY: 'PRIMARY', ADDED: 'ADDED' };
// Copy: ratified #32 / #57 — constants/admission.js (re-exported for existing imports).
export { VIEWER_RELATIONSHIP_TAG };
const TONE = {
  PRIMARY: 'border-teal-400 bg-teal-100 dark:bg-teal-900/40 text-teal-800 dark:text-teal-200',
  ADDED: 'border-indigo-400 bg-indigo-100 dark:bg-indigo-900/40 text-indigo-800 dark:text-indigo-200',
};

export default function ViewerRelationshipChip({ relationship, you = false, testId }) {
  const text = (you ? YOU_TEXT : VIEWER_RELATIONSHIP_TAG)[relationship];
  if (!text) return null;
  return (
    <span
      className={`inline-flex items-center rounded-full border px-1.5 py-0.5 text-[10.5px] font-semibold whitespace-nowrap flex-none ${TONE[relationship]}`}
      data-testid={testId}
    >
      {text}
    </span>
  );
}
